import React, {useState} from 'react';
import ChangeMonthCalendar from '../../../PersonalOffice/MediaAndNews/ChangeMonthCalendar';
import {useClickOutside} from '../../../hooks/useClickOutside';

type Props = {
	currentMonthName: string;
	setCurrentMonth?: (currentMonth: string) => void;
	setCurrentMonthName: (currentMonthName: string) => void;
	setAmountOfMonth: (amountOfMonth: number) => void;
};
const FilterMonth: React.FC<Props> = ({
	currentMonthName,
	setCurrentMonthName,
	setAmountOfMonth,
	setCurrentMonth,
}) => {
	const [showCalendar, setShowCalendar] = useState(false);
	const handleCloseCalendar = () => {
		setShowCalendar(false);
	};
	const calendarContainerRef =
		useClickOutside<HTMLDivElement>(handleCloseCalendar);
	return (
		<div
			className="form-filter__item form-filter__item-select"
			ref={calendarContainerRef}
		>
			<button
				onClick={() => setShowCalendar(!showCalendar)}
				type={'button'}
				className="form-filter__select select-name"
			>
				{currentMonthName}
			</button>
			{showCalendar && (
				<ChangeMonthCalendar
					setCurrentMonthName={setCurrentMonthName}
					close={setShowCalendar}
					setAmountOfMonth={setAmountOfMonth}
					setCurrentMonth={setCurrentMonth}
				/>
			)}
		</div>
	);
};

export default FilterMonth;
